import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div``

export const CloseIcon = styled.div`
  cursor: pointer;
  color: ${colors.strongGray};
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 5px 10px 5px 10px;
`

export const CheckBoxArea = styled.div`
  display: grid;
  padding: 20px 15.5px;
  grid-template-columns: 1fr 1fr;
  row-gap: 20px;
  border-radius: 12px;
  border: 1px solid ${colors.grayBackground};
`

export const Section = styled.div`
  margin: 12px 0;
`

export const Area = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
export const Subtitle = styled.div`
  text-align: flex-start;
  font-size: 16px;
  color: ${colors.strongGray};
`
export const Title = styled.div`
  font-size: 24px;
  margin: 10px 0 10px 0;
  font-family: Circular-Std-Bold;
`
export const Divisor = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.softGray};
  padding-bottom: 10px;
  margin-bottom: 15px;
`
export const Textarea = styled.textarea`
  width: 100%;
  font-size: 16px;
  font-family: inherit;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid ${colors.softGray};
  color: ${colors.titleStrongBlack};
  box-sizing: border-box;
  padding: 12px 12px 12px 16px;
  gap: 12px;
  vertical-align: baseline;
  resize: none;
  background-color: white;
  overflow: hidden;
  &:disabled {
    color: ${colors.strongGray};
  }

  @media (max-width: 550px) {
    font-size: 14px;
  }
`
export const Icon = styled.div`
  color: ${(props) => (!props.state ? colors.strongGray : colors.titleStrongWhite)};
`
export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  gap: 10px;
`

export const CheckBoxText = styled.text`
  color: ${colors.titleStrongBlack};
  display: flex;
  align-items: center;
`

export const CheckBoxContainer = styled.text`
  display: flex;
  lign-items: center;
  margin-top: 15px;
  margin-bottom: 15px;
`
